
import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
// import { CustomModeler } from 'tnx-admin-service/workflowcore/custom-modeler';
import { map, takeUntil } from 'rxjs/operators';
import { SelectItemGroup } from 'tn-custom-primeng/api';
import { FileUpload } from 'tn-custom-primeng/fileupload';
import { Param, Swagger } from 'tnx-admin-service/workflowcore/workflowdefine/models';
import { WorkflowDefineService } from 'tnx-admin-service/workflowcore/workflowdefine/services';
import {
    CommonService,
    ComponentBase,
    ComponentContextService,
    NotifierService
} from 'tnx-shared';
@Component({
    selector: 'workflowdefine-form',
    templateUrl: './workflowdefine-form.component.html',
    styleUrls: ['./workflowdefine-form.component.scss'],
    providers: [ComponentContextService],
})
export class WorkflowDefineFormComponent extends ComponentBase implements OnInit {

    id = 0;
    message: string;
    title = 'Sơ đồ quy trình';
    modeler;

    closeResult: string;

    display = false;

    showDisplay = false;
    isExpandKeyValue = false;
    arrServices = [];
    arrTemplate = [];
    arrEForm = [];
    arrCompleteStep = [];
    eFormSelected = [];
    completeFormSelected = [];

    arrEndpoint: SelectItemGroup[] = [];

    swagger: Swagger = new Swagger();

    arrExtendDeleted = [];

    data = [];

    elementType = '';
    elementSelectedType = '';
    elementSelectedId = '';
    elementSelectedName = '';
    serviceCode = '';
    entityCode = '';

    param: Param = new Param();

    cols: any[];

    itemTemp = '';

    itemWorkflowStep: any = {};

    itemWorkflowDefine = {
        name: '',
        serviceCode: '',
        entityCode: '',
        codeTag: '',
        versionTag: '',
        serviceCodeTag: '',
        entityCodeTag: ''
    };

    dataParams = [];

    isDisabled = true;

    uploadedFiles: any[] = [];

    typeDeadline = 'ngày';

    keyFilter = 'int';

    httpRequestSelected: string;

    arrEntityCode = [];

    @ViewChild('downloadDiagram') downloadDiagram: ElementRef;
    @ViewChild('fileUpload') fileUpload: FileUpload;
    workflowForms = [];
    workflowCompleteForms = [];
    workflowTemplates = [];
    deadline: number;
    isDate: boolean;
    httpRequest: any;
    isCreateTask = true;
    topic: any;

    topicData = [];
    topicCols = [];
    extendCols = [];

    index = 0;
    propertiesPanel: any;
    isServiceTask = true;

    arrWorkflow = [];

    formGroup: FormGroup;

    elementSelected: any;

    currentIndex = 0;
    _unsubscribeAll = new Subject<any>();
    constructor(
        protected _injector: Injector,
        private _workflowDefineService: WorkflowDefineService,
        private _translateService: TranslateService,
        private _router: Router,
        private _notifierService: NotifierService,
        protected _activatedRoute: ActivatedRoute,
        protected _commonService: CommonService
    ) {
        super(_injector);

        this.formGroup = new FormGroup({
            serviceCodeTag: new FormControl('', [Validators.required]),
            nameProcess: new FormControl('', [Validators.required]),
            codeTagProcess: new FormControl('', [Validators.required]),
            versionTag: new FormControl('', [Validators.required]),
            subProcess: new FormControl(''),
            correlation: new FormControl('', [Validators.required]),
            name: new FormControl('', [Validators.required]),
            codeTag: new FormControl('', [Validators.required]),
            organizations: new FormControl(''),
            users: new FormControl(''),
            processingForms: new FormControl(''),
            templateForms: new FormControl(''),
            deadlineTag: new FormControl(''),
            isDayTag: new FormControl(''),
            autoFinishTag: new FormControl(''),
            extendKey: new FormControl(''),
            extendValue: new FormControl(''),
            topicTag: new FormControl(''),
            topicKey: new FormControl(''),
            topicValue: new FormControl(''),
            topicType: new FormControl('')
        });
    }

    ngOnInit() {
        // super.ngOnInit();
        // this.setting.baseService = this._workflowDefineService;
        // this.setting.schema = <FormSchemaBase[]>[
        //     new TextControlSchema({
        //         field: 'persistenceId',
        //         label: ''
        //     }),
        //     new DateTimeControlSchema({
        //         field: 'createTime',
        //         label: 'Thời gian tạo'
        //     }),
        //     new TextControlSchema({
        //         field: 'content',
        //         label: 'Nội dung'
        //     }),
        //     new TextControlSchema({
        //         field: 'name',
        //         label: 'Tên quy trình'
        //     }),
        //     new TextControlSchema({
        //         field: 'description',
        //         label: 'Mô tả'
        //     }),
        //     new TextControlSchema({
        //         field: 'status',
        //         label: 'Trạng thái'
        //     }),
        //     new TextControlSchema({
        //         field: 'bpmnContent',
        //         label: 'Nội dung bpmn'
        //     }),
        //     new TextControlSchema({
        //         field: 'code',
        //         label: 'Mã quy trình'
        //     })
        // ];

        // this.modeler = new CustomModeler({
        //     container: '#canvas',
        //     width: '100%',
        //     height: '80vh',
        //     additionalModules: [
        //     ]
        // });

        const eventBus = this.modeler.get('eventBus');

        eventBus.on('element.click', e => {
            this.isServiceTask = false;
            this.elementSelected = e.element;
            if (e.element.type === 'bpmn:Process') {
                this.formGroup.controls['serviceCodeTag'].setValidators(
                    Validators.required
                );
                this.formGroup.controls[
                    'serviceCodeTag'
                ].updateValueAndValidity();
                this.formGroup.controls['nameProcess'].setValidators(
                    Validators.required
                );
                this.formGroup.controls['nameProcess'].updateValueAndValidity();
                this.formGroup.controls['codeTagProcess'].setValidators(
                    Validators.required
                );
                this.formGroup.controls[
                    'codeTagProcess'
                ].updateValueAndValidity();

                this.formGroup.controls['name'].setValidators(
                    Validators.nullValidator
                );
                this.formGroup.controls['name'].updateValueAndValidity();
                this.formGroup.controls['codeTag'].setValidators(
                    Validators.nullValidator
                );
                this.formGroup.controls['codeTag'].updateValueAndValidity();
                this.formGroup.controls['correlation'].setValidators(
                    Validators.nullValidator
                );
                this.formGroup.controls['correlation'].updateValueAndValidity();

                this.index = 0;
                this.isDisabled = true;
                this.itemWorkflowDefine = {
                    name: '',
                    serviceCode: '',
                    entityCode: '',
                    codeTag: '',
                    versionTag: '1',
                    serviceCodeTag: '',
                    entityCodeTag: ''
                };
                if (e.element.businessObject.name) {
                    this.itemWorkflowDefine.name =
                        e.element.businessObject.name;
                }

                if (e.element.businessObject.$attrs) {
                    Object.keys(e.element.businessObject.$attrs).forEach(
                        key => {
                            if (e.element.businessObject.$attrs[key]) {
                                try {
                                    this.itemWorkflowDefine[key] = JSON.parse(
                                        e.element.businessObject.$attrs[key]
                                    );
                                } catch (exception) {
                                    this.itemWorkflowDefine[key] =
                                        e.element.businessObject.$attrs[key];
                                }
                            }
                        }
                    );
                }
            } else {
                this.isDisabled = false;
                this.itemWorkflowStep = {};

                if (e.element.type !== 'bpmn:ServiceTask' && e.element.type !== 'bpmn:SubProcess' && e.element.type !== 'bpmn:Task')
                    this.isServiceTask = false;
                else this.isServiceTask = true;

                this.formGroup.controls['serviceCodeTag'].setValidators(Validators.nullValidator);
                this.formGroup.controls['serviceCodeTag'].updateValueAndValidity();
                this.formGroup.controls['nameProcess'].setValidators(Validators.nullValidator);
                this.formGroup.controls['nameProcess'].updateValueAndValidity();
                this.formGroup.controls['codeTagProcess'].setValidators(Validators.nullValidator);
                this.formGroup.controls['codeTagProcess'].updateValueAndValidity();
                this.formGroup.controls['name'].setValidators(Validators.required);
                this.formGroup.controls['name'].updateValueAndValidity();
                this.formGroup.controls['codeTag'].setValidators(Validators.required);
                this.formGroup.controls['codeTag'].updateValueAndValidity();

                if (e.element.type === 'bpmn:SubProcess') {
                    this.formGroup.controls['correlation'].setValidators(Validators.required);
                    this.formGroup.controls['correlation'].updateValueAndValidity();
                } else {
                    this.formGroup.controls['correlation'].setValidators(Validators.nullValidator);
                    this.formGroup.controls['correlation'].updateValueAndValidity();
                }
                console.log(e.element.businessObject.$attrs);

                if (e.element.businessObject.$attrs) {
                    // remove all undefined value
                    Object.keys(e.element.businessObject.$attrs).forEach(
                        key => {
                            if (e.element.businessObject.$attrs[key] == 'undefined'
                                || e.element.businessObject.$attrs[key] == 'null') {
                                e.element.businessObject.$attrs[key] = null;
                            }
                        });

                    if (this.arrExtendDeleted.length && this.arrExtendDeleted.findIndex(x => x.key == e.element.id) > -1) {
                        let arr = JSON.parse(this.elementSelected.businessObject.$attrs['extendData']);

                        const arrKeyDeleted = [];
                        arr.forEach((val, index) => {
                            const temp = val.key;
                            const ck = this.arrExtendDeleted.find(s => s.value.key == temp);
                            if (ck)
                                arrKeyDeleted.push(ck.value['key']);
                        });

                        arr = arr.filter(x => !arrKeyDeleted.includes(x.key));

                        this.arrExtendDeleted = [];
                        e.element.businessObject.$attrs['extendData'] = JSON.stringify(arr);
                    }

                    if (!e.element.businessObject.$attrs.isDayTag)
                        e.element.businessObject.$attrs.isDayTag = 'false';
                    if (!e.element.businessObject.$attrs.isCreateTaskTag)
                        e.element.businessObject.$attrs.isCreateTaskTag = 'true';
                    if (!e.element.businessObject.$attrs.autoFinishTag)
                        e.element.businessObject.$attrs.autoFinishTag = 'false';
                    Object.keys(e.element.businessObject.$attrs).forEach(
                        key => {
                            const keyTemp = key;
                            if (e.element.businessObject.$attrs[keyTemp]) {
                                try {
                                    // if (keyTemp == 'users') {
                                    //     this.itemWorkflowStep[keyTemp] = e.element.businessObject.$attrs[keyTemp].split(',').map(Number);
                                    // } else
                                    this.itemWorkflowStep[keyTemp] = JSON.parse(e.element.businessObject.$attrs[keyTemp]);

                                    // add formgroup control
                                    if (keyTemp === 'extendData') {
                                        for (const index in this.itemWorkflowStep[keyTemp]) {
                                            this.itemWorkflowStep[keyTemp][index].index = this.currentIndex;
                                            this.formGroup.addControl(`extendKey${this.currentIndex}`, new FormControl());
                                            this.formGroup.addControl(`extendValue${this.currentIndex}`, new FormControl());
                                            this.currentIndex++;
                                        }
                                    }
                                } catch (exception) {
                                    this.elementSelected.businessObject.$attrs[keyTemp] = e.element.businessObject.$attrs[keyTemp];
                                }
                            }
                        }
                    );
                }
            }
        });

        this._activatedRoute.params
            .pipe(
                map(params => params['id']),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(pid => {
                if (pid > 0) {
                    this.id = pid;
                    this._workflowDefineService.getDetail(this.id).then(rs => {
                        console.log('item', rs);
                        this.modeler.importXML(
                            rs.data.bpmnContent,
                            this.modeler.handleError
                        );
                    });
                    // this.getDetail();
                } else {
                    this._workflowDefineService.loadDefaultBpmn().then(x => {
                        this.modeler.importXML(x, () => { });
                    });
                }
            });

        this.topicCols = [
            {
                field: 'key',
                header: this._translateService.instant('Key'),
                visible: true,
                dataType: 'key'
            },
            {
                field: 'value',
                header: this._translateService.instant('Value'),
                visible: true,
                dataType: 'value'
            },
            {
                field: 'type',
                header: this._translateService.instant('Type'),
                visible: true,
                dataType: 'type'
            }
        ];

        this.extendCols = [
            {
                field: 'key',
                header: this._translateService.instant('Key'),
                visible: true,
                dataType: 'key'
            },
            {
                field: 'value',
                header: this._translateService.instant('Value'),
                visible: true,
                dataType: 'value'
            }
        ];
    }

    back() {
        if (this.id > 0) {
            this._router.navigate(['../..'], { relativeTo: this._activatedRoute });
        } else {
            this._router.navigate(['..'], { relativeTo: this._activatedRoute });
        }
    }

    import(event) {
        const reader = new FileReader();

        reader.onload = e => {
            const xml = reader.result;
            this.modeler.importXML(xml, this.modeler.handleError);
        };
        reader.readAsText(event.files[0]);
        this.fileUpload.clear();
    }

    exportDiagram() {
        this.modeler.saveXML((err: any, xml: any) => {
            this.setEncoded(
                this.downloadDiagram.nativeElement,
                'diagram.bpmn',
                err ? null : xml
            );
        });
    }

    setEncoded(link, name, data) {
        const encodedData = encodeURIComponent(data);
        if (data) {
            link.href =
                'data:application/bpmn20-xml;charset=UTF-8,' + encodedData;

            link.download = name;
        } else {
            link.removeClass('active');
        }
    }

    removeElement(arr: any[], item): boolean {
        if (arr.length > 0) {
            const checkIndex = arr.findIndex(
                x => x.stepType === item.stepType && x.stepId === item.stepId
            );
            if (checkIndex > -1) {
                // arr.splice(checkIndex, 1);
                return true;
            }
        }
        return false;
    }

    saveWorkflow() {
        this.modeler.saveXML((err: any, xml: any) => {
            this._workflowDefineService
                .createWfDefinition(this._commonService.htmlEncode(xml))
                .then(
                    rs => {
                        if (!rs.error) {
                            this._notifierService.showInsertDataSuccess();
                            this.back();
                        } else {
                            this._notifierService.showWarning(rs.error);
                        }
                    },
                    error => this._notifierService.showInsertDataFailed()
                );
        });
    }

    assignProcess(key: string) {
        if (key !== 'name')
            this.elementSelected.businessObject.$attrs[key] = this.itemWorkflowDefine[key];
        else
            this.elementSelected.businessObject.name = this.itemWorkflowDefine[key];
    }

    changeName(element) {
        const eventBus = this.modeler.get('eventBus');

        eventBus.fire('element.changed', { element });
    }

    changeKeyValue(key: string) {
        if (this.itemWorkflowStep)
            this.elementSelected.businessObject.$attrs[key] = JSON.stringify(this.itemWorkflowStep[key]);
    }

    deleteExtendData(itemExtendData) {
        this.itemWorkflowStep.extendData = this.itemWorkflowStep.extendData.filter(
            (val, i) => {
                if (val.key === itemExtendData.key) {
                    this.formGroup.removeControl(`extendKey${val.index}`);
                    this.formGroup.removeControl(`extendValue${val.index}`);

                    // this.itemWorkflowStep.extendData.splice(i, 1);
                    // let arr = JSON.parse(this.elementSelected.businessObject.$attrs['extendData']);
                    // arr.splice(i, 1);
                    const temp = this.elementSelected.id;
                    this.arrExtendDeleted.push({ key: temp, value: val });

                    // console.log(arr);

                    return false;
                }

                return true;
            }
        );
    }

    addRowExtend() {
        const obj = { key: '', value: '', index: this.currentIndex };
        if (!this.itemWorkflowStep.extendData) {
            this.itemWorkflowStep.extendData = [];
        }

        const extendData = [...this.itemWorkflowStep.extendData];
        extendData.push(obj);

        this.formGroup.addControl(`extendKey${this.currentIndex}`, new FormControl());
        this.formGroup.addControl(`extendValue${this.currentIndex}`, new FormControl());
        this.currentIndex++;
        this.itemWorkflowStep.extendData = extendData;
    }

    addBasicKeyValue() {
        this.addBasicKeyValueItem('taskName', '{0}');
        this.addBasicKeyValueItem('entityStatusCodeType');
        this.addBasicKeyValueItem('entityStatusCode');
        this.addBasicKeyValueItem('reTaskName', 'Xử lý lại {0}');
        this.addBasicKeyValueItem('reEntityStatusCode');
        this.addBasicKeyValueItem('taskCategoryCode');
        this.addBasicKeyValueItem('form');
    }

    addBasicKeyValueItem(key, defaultValue = '') {
        console.log('extend data', this.itemWorkflowStep.extendData);
        if (!this.itemWorkflowStep.extendData || this.itemWorkflowStep.extendData.findIndex(x => x.key === key) === -1) {
            if (!this.itemWorkflowStep.extendData) {
                this.itemWorkflowStep.extendData = [];
            }
            this.itemWorkflowStep.extendData.splice(this.itemWorkflowStep.length, 0, { key, value: defaultValue, index: this.currentIndex });

            this.formGroup.addControl(`extendKey${this.currentIndex}`, new FormControl());
            this.formGroup.addControl(`extendValue${this.currentIndex}`, new FormControl());
            this.currentIndex++;
        }
    }

    expandKeyValue() {
        this.isExpandKeyValue = !this.isExpandKeyValue;
    }

    addRowTopic() {
        const obj = {};
        if (!this.itemWorkflowStep.topicData) {
            this.itemWorkflowStep.topicData = [];
        }

        const topicData = [...this.itemWorkflowStep.topicData];
        topicData.push(obj);
        this.itemWorkflowStep.topicData = topicData;
    }
    // async onFormInitialized(formEvent: EventData) {
    //     // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    // }

    // async onFormEvent(evt) {
    //     // các event trong form
    //     console.log(evt);
    // }

    // async modifyDetailData(data) {
    //     // xử lý dữ liệu lấy từ get detail về
    // }

    // async onAfterGetDetail() {
    //     // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    // }

    // onBeforeSave() {
    //     // trước khi lưu
    // }
}

